import { render, staticRenderFns } from "./EditCustomerGroupModal.vue?vue&type=template&id=04c491ee"
import script from "./EditCustomerGroupModal.vue?vue&type=script&lang=js"
export * from "./EditCustomerGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports